export const BLOCK_CHILDREN_TYPES_HASH = {
  LESSON_PLAN: 'LessonPlan',
  DAILY_PLAN: 'DailyPlan',
};
